(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nene-collection-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nene-collection-more')) {
  customElements.define('nene-collection-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.abort = new AbortController();
      this.busy = false;
      this.label = this.link.textContent;
      this.link.addEventListener('click', event => { event.preventDefault(); this.loadMore(true); }, { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) this.loadMore(false); }, { rootMargin: '500px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    async loadMore(manual) {
      if (this.busy || this.link.hidden) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      try {
        const url = new URL(this.link.href, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Unexpected destination');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.abort.signal });
        if (!response.ok) throw new Error('Unable to load products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = html.querySelector('#product-grid');
        const grid = this.closest('.collection').querySelector('#product-grid');
        if (!incomingGrid || !grid || !this.isConnected) throw new Error('Missing product grid');
        const items = Array.from(incomingGrid.children);
        if (!items.length) throw new Error('No product items');
        items.forEach(item => { item.classList.add('scroll-trigger--cancel'); grid.append(item); });
        const next = html.querySelector('nene-collection-more a');
        this.status.textContent = this.dataset.loaded.replace('[count]', String(items.length));
        if (next) this.link.href = next.href;
        else { this.link.hidden = true; this.observer.disconnect(); }
        if (manual) { const firstLink = items[0].querySelector('h3 a'); firstLink?.focus({ preventScroll: true }); }
      } catch (error) {
        if (error.name !== 'AbortError') { this.status.textContent = this.dataset.error; this.observer.disconnect(); }
      } finally { this.busy = false; this.removeAttribute('aria-busy'); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nene-fsc-typography"] && !Shopify.designMode) return;
  try {
    (() => {
  const excluded = 'script,style,noscript,textarea,input,select,option,code,pre,svg,math,sup,sub,[contenteditable]:not([contenteditable="false"])';
  const pattern = /\bFSC[ \u00a0]*®/g;
  function format(root) {
    if (!root || !root.isConnected) return;
    const nodes = [];
    if (root.nodeType === Node.TEXT_NODE) nodes.push(root);
    else {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
    }
    for (const node of nodes) {
      if (!node.parentElement || node.parentElement.closest(excluded)) continue;
      const matches = [...node.data.matchAll(pattern)];
      if (!matches.length) continue;
      const fragment = document.createDocumentFragment();
      let offset = 0;
      for (const match of matches) {
        fragment.append(document.createTextNode(node.data.slice(offset, match.index) + 'FSC'));
        const mark = document.createElement('sup');
        mark.className = 'nene-fsc-mark';
        mark.textContent = '®';
        fragment.append(mark);
        offset = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(node.data.slice(offset)));
      node.replaceWith(fragment);
    }
  }
  function start() {
    format(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') format(record.target);
        else for (const node of record.addedNodes) format(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nene-localization"] && !Shopify.designMode) return;
  try {
    function setupNeneLocales(root){
  root.querySelectorAll('.nene-locale-form').forEach(form=>{
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    const market=form.querySelector('[data-nene-market]');
    const language=form.querySelector('[data-nene-language]');
    const sync=()=>{
      const allowed=market.value==='US'?['en','es']:market.value==='GB'?['en']:null;
      for(const option of language.options){const unavailable=allowed!==null&&!allowed.includes(option.value);option.hidden=unavailable;option.disabled=unavailable;}
      language.options[0].text=market.value==='GB'?'English (UK)':market.value==='US'?'English (US)':'English';
      if(allowed&&!allowed.includes(language.value))language.value='en';
    };
    market.addEventListener('change',sync);sync();
    form.addEventListener('submit',()=>{sync();const back=form.querySelector('[name="return_to"]');if(back)back.value=window.location.pathname+window.location.search+window.location.hash;form.querySelector('button[type="submit"]').setAttribute('aria-busy','true');});
  });
}
setupNeneLocales(document);
document.addEventListener('shopify:section:load',event=>setupNeneLocales(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nene-localization[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});});
document.addEventListener('click',event=>document.querySelectorAll('.nene-localization[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nene-market-suggestion"] && !Shopify.designMode) return;
  try {
    function neneChooseLocation(data, config, browserLanguages) {
  const eu = new Set('AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(','));
  const market = country => country === 'US' ? 'US' : country === 'GB' ? 'UK' : eu.has(country) ? 'EU' : null;
  const parts = data.suggestions?.[0]?.parts || {};
  const country = (parts.country?.handle || data.detected_values?.country?.handle || config.country || '').toUpperCase();
  if (!config.countries.includes(country) || !market(country)) return null;
  const allowed = config.marketLanguages[market(country)] || [];
  const regional = {FR:'fr',DE:'de',AT:'de',IT:'it',NL:'nl',ES:'es',PL:'pl'}[country] || 'en';
  const candidates = [...(browserLanguages || []), parts.language?.handle, regional, 'en'];
  const language = candidates.filter(Boolean).map(value => value.toLowerCase().split('-')[0]).find(value => allowed.includes(value));
  if (!language || (country === config.country && language === config.language.split('-')[0])) return null;
  return {country, language, market:market(country)};
}
(() => {
  const dialog = document.getElementById('NeneMarketSuggestion');
  if (!dialog || window.Shopify?.designMode || typeof dialog.showModal !== 'function') return;
  const config = JSON.parse(dialog.querySelector('[data-nene-suggestion-config]').textContent);
  const key = 'nene_locale_choice_v1';
  const remember = () => {try {localStorage.setItem(key, String(Date.now() + 30 * 86400000));} catch {}};
  const hasChoice = () => {try {return Number(localStorage.getItem(key)) > Date.now();} catch {return false;}};
  const stay = () => {remember();dialog.close();};
  dialog.querySelectorAll('[data-nene-stay]').forEach(button => button.addEventListener('click', stay));
  dialog.addEventListener('cancel', remember);
  dialog.querySelector('form').addEventListener('submit', () => {remember();dialog.querySelector('[type="submit"]').setAttribute('aria-busy', 'true');});
  document.addEventListener('submit', event => {if (event.target.matches('.nene-locale-form')) {remember();dialog.close();}}, true);
  const suggest = async () => {
    if (hasChoice()) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams({'country[enabled]':'true','country[exclude]':config.country,'language[enabled]':'true','language[exclude]':config.language});
      const response = await fetch(root + 'browsing_context_suggestions.json?' + params, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) return;
      const destination = neneChooseLocation(await response.json(), config, navigator.languages);
      if (!destination || hasChoice() || document.querySelector('dialog[open]')) return;
      const languages = {en:'English',es:'Español',de:'Deutsch',fr:'Français',it:'Italiano',nl:'Nederlands',pl:'Polski'};
      const copy = config.translations[destination.language] || config.translations.en;
      dialog.lang = destination.language;
      dialog.querySelector('h2').textContent = copy.title;
      dialog.querySelector('#NeneMarketSuggestionDescription').textContent = copy.description;
      dialog.querySelector('.nene-market-suggestion__accept').textContent = copy.switch;
      dialog.querySelector('.nene-market-suggestion__stay').textContent = copy.stay;
      dialog.querySelector('.nene-market-suggestion__note').textContent = copy.note;
      dialog.querySelector('.nene-market-suggestion__close').setAttribute('aria-label', copy.close);
      let countryName = destination.country;
      try {countryName = new Intl.DisplayNames([destination.language], {type:'region'}).of(destination.country);} catch {}
      const region = copy.markets[destination.market];
      dialog.querySelector('[data-nene-destination]').textContent = region + (destination.market === 'EU' ? ' · ' + countryName : '') + ' · ' + languages[destination.language];
      dialog.querySelector('[name="country_code"]').value = destination.country;
      dialog.querySelector('[name="language_code"]').value = destination.language;
      const returnTo = dialog.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      dialog.showModal();
    } catch {} finally {clearTimeout(timeout);}
  };
  if (document.readyState === 'complete') setTimeout(suggest, 1800);
  else window.addEventListener('load', () => setTimeout(suggest, 1800), {once:true});
})();
  } catch(e) { console.error(e); }
})();

})();
